import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 90 90"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "45.247",
      cy: "44.753",
      r: "42.628",
      stroke: "currentColor",
      "stroke-width": "3.48"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m37.09 57.47 21.438-12.06c1.125-.633 1.125-2.251 0-2.884L37.09 30.466a1.654 1.654 0 0 0-2.465 1.443v24.118a1.654 1.654 0 0 0 2.465 1.442m.843-22.733V53.2l16.41-9.231z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }